import {Route,  BrowserRouter as Router, Routes} from "react-router-dom";
import {Home} from "./Home";
import {Post} from "./Post";
import {Category} from "./Category";
import {Publications} from "./Publications";
import React, {useState} from "react";
import {Kontakt} from "./Kontakt";

export function App( ) {
    const [isOpen, setIsOpen] = useState(false);
    return <div className="page">
        <div className="main-menu">
            <a className="logo-wrapper" href="/">
                <img src="/logo.svg"/>
            </a>
            <button className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
                {isOpen ? "✕" : "☰"}
            </button>
            <nav className={`menu-navigation ${isOpen ? "open" : ""}`}>
                <a href={"/kategoria/vzdelavacie-aktivity"}>Vzdelávacie aktivity</a>
                <a href={"/kategoria/foto-potulky"}>Foto potulky</a>
                <a href={"/kategoria/slovak-art-ways"}>Slovak Art Ways</a>
                <a href={"/kategoria/aktualne-akcie"}>Aktuálne akcie</a>
                <a href={"/kategoria/clanky"}>Články</a>
                <a href={"/publikacie"}>Publikácie</a>
                <a href={"/kontakt"}>Kontakt</a>
            </nav>
        </div>
        <div className="content">
            <Router>
                <Routes>
                <Route path="/" element={<Home />} />
                    <Route path="/kategoria/:category" element={<Category />} />
                    <Route path="/post/:postId" element={<Post />} />
                    <Route path="/publikacie" element={<Publications />} />
                    <Route path="/kontakt" element={<Kontakt />} />
                </Routes>
            </Router>
        </div>
        <div className="footer">
            <div className="copyright">
                <p>Copyright © {(new Date().getFullYear())} pointA o.z. <br/>
                Vytvorilo <a href={"https://najsu.com/"} target="_blank" rel="noreferrer">najsu</a>
                </p>
            </div>
            <div>

            </div>
            <div className={"facebook-link"}>
                <a href="https://www.facebook.com/profile.php?id=100075795622577" target="_blank" rel="noreferrer">
                    <img src="/assets/fb.png" alt="facebook-logo" className="fb-logo" />
                    /PointA
                </a>
            </div>
        </div>
    </div>
}